import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';

const DICCIONARIO_PREGUNTAS = {
  // --- INSPECCIÓN LOCATIVA ---
  "loc_1": "Cuenta con concepto sanitario",
  "loc_2": "Estado general de techos, paredes, pisos, puertas, ventanas, vidrios, y fachadas",
  "loc_3": "Iluminación adecuada en todas las áreas",
  "loc_4": "Ventilación adecuada (natural o mecánica)",
  "loc_5": "Estado de gondolas, estanterias, anaqueles y mobiliario",
  "loc_6": "Protección contra caídas (barandas, escaleras seguras, pisos y/o cintas antideslizantes)",
  "loc_7": "Hay red de internet para los equipos tecnologicos",
  "loc_8": "Se cuenta con recurso hidroelectrico",
  "loc_9": "Se cuenta con agua potable",
  "loc_10": "Las áreas de trabajo cumplen con el nivel de confort de ruido",
  "ord_1": "Estado general de aseo en el PDV",
  "ord_2": "Pasillos libres de obstáculos",
  "ord_3": "Mercancía correctamente ubicada en las estanterías",
  "ord_4": "Estanterías libres de suciedad y correctamente higienizadas",
  "ord_5": "Vigencia de certificados de fumigacion y control de plagas",
  "ord_6": "Puntos ecologicos con bolsa según codigo de color, tapa y clasificación de residuos",
  "ord_7": "Vigencia certificado limpieza y desinfeccion de tanques de almacenamiento de agua potable",
  "ord_8": "Higiene personal (dotación, epp, uñas, cabello, maquillaje y accesorios)",
  "ord_9": "Los cuadros y/o avisos estan limpios y firmes",
  "ord_10": "Los equipos de computo estan limpios y ubicados correctamente",
  "ord_11": "El área de vestidores y/o descanso del personal estan debidamente dotada y limpia",
  "ord_12": "Los Baños estan debidamente dotados y limpios",
  "ord_13": "Áreas de cajas y servicio al cliente libres de desorden",
  "ord_14": "Los elementos de aseo se encuentran limpios (traperos, escobas, trapos, etc)",
  "ord_15": "Carros y canastillas higienizados y en buen estado (sin ruedas dañadas ni estructuras rotas)",
  "ord_16": "Vertimientos generados por refigeradores, congeladores o tuberias",
  "ord_17": "Orden y limpieza de las carpetas y documentación",
  "man_1": "Funcionamiento adecuado de refigeradores y congeladores (temperatura)",
  "man_2": "Sellado hermético de puertas y tapas de refrigeradores y/o congeladores",
  "man_3": "Termómetros calibrados",
  "man_4": "Ventiladores y ductos libres de polvo y residuos",
  "man_5": "Equipos de corte (cuchillos, rebanadoras, sierras) afilados y en óptimas condiciones",
  "man_6": "Herramientas de trabajo en buen estado (sin desgaste excesivo, sin piezas rotas)",
  "man_7": "Balanzas calibradas y operativas",
  "qui_1": "Todos los productos químicos cuentan con su etiqueta original",
  "qui_2": "Productos químicos almacenados en áreas separadas de alimentos y artículos de consumo",
  "qui_3": "Fichas técnicas de productos quimicos",
  "qui_4": "Las areas de almacenamiento de productos quimicos estan señalizadas",
  "ele_1": "Los cables estan canalizados, protegidos y bien fijados",
  "ele_2": "Los tableros y paneles electricos estan señalizados y tienen facil acceso",
  "seg_1": "Se cuenta con extintores suficientes en el PDV (1 cada 200 m²)",
  "seg_2": "Los extintores estan ubicados en su soporte, señalizados y con facil acceso",
  "seg_3": "Vigencia y presurización del extintor",
  "seg_4": "El tipo de extintor es acorde al riesgo presente",
  "seg_5": "Se cuenta con botiquin portatil tipo A",
  "seg_6": "Los elementos del botiquin estan vigentes y en buen estado",
  "seg_7": "El botiquin esta ubicado en un lugar visible, de facil acceso y señalizado",
  "seg_8": "Camilla de emergencias en lugar visible, de facil acceso y señalizada",
  "seg_9": "La araña de transporte de la camilla se encuentra en buen estado",
  "seg_10": "Se cuenta con señalizacion y demarcación de salidas de emergencia y rutas de evacuacion",
  "seg_11": "Existe señalización de espacios libres de humo",
  "seg_12": "Existe señalización de control y monitoreo por camaras de seguridad",
  "seg_13": "Los brigadistas del PDV estan identificados con chaleco",
  "seg_14": "Los formatos manejados en el PDV se encuentran al día",
  "seg_15": "Los documentos pertinentes a SST se encuentran al dia (certificados, examenes)",
  "seg_16": "Se presentaron accidentes laborales durante el mes",
  "seg_17": "Se reportaron enfermedades laborales durante el mes",
  
  // --- REPORTE DE NOVEDADES DE MANTENIMIENTO ---
  "rep_mant_1": "Se requiere intervención correctiva en paredes o muros (filtraciones, humedad o grietas)",
  "rep_mant_2": "Daños o fallas en luminarias, interruptores o cableado eléctrico expuesto",
  "rep_mant_3": "Problemas en sistemas hidrosanitarios (fugas en tuberías, grifería o desagües)",
  "rep_mant_4": "Deterioro en puertas, chapas, ventanas o vidrios que comprometan la seguridad",

  // --- LIMPIEZA DE BAÑOS ---
  "ext_1": "Limpieza de Paredes (Exterior)",
  "ext_2": "Limpieza de Corredores (Exterior)",
  "ext_3": "Limpieza Puerta de ingreso (Exterior)",
  "int_1": "Pisos (Interior)",
  "int_2": "Paredes (Interior)",
  "int_3": "Techos (Interior)",
  "int_4": "Puertas y divisiones (Interior)",
  "int_5": "Espejos (Interior)",
  "int_6": "Lavamanos (Interior)",
  "int_7": "Interruptores de iluminación (Interior)",
  "int_8": "Sanitarios (Interior)",
  "int_9": "Canecas (Interior)",
  "int_10": "Dispensador de jabón de manos (Interior)",
  "int_11": "Dispensadores de papel (Interior)",
  "kit_1": "Jabon para manos (Kit)",
  "kit_2": "Escobas, cepillo, trapero y balde (Kit)",
  "kit_3": "Jabon para piso y desinfectante para baños (Kit)",
  "kit_4": "Estopa (Kit)",
  "bio_1": "El personal usa tapabocas (Bioseguridad)",
  "bio_2": "El personal usa guantes de nitrilo (Bioseguridad)"
};

const NOMBRES_MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const CATEGORIAS_LIMPIEZA_ESTRUCTURA = [
  { area: "INFRAESTRUCTURA", items: [{id:"inf_pisos", nombre:"Pisos"}, {id:"inf_paredes", nombre:"Paredes"}, {id:"inf_techos", nombre:"Techos"}, {id:"inf_vidrios", nombre:"Vidrios"}, {id:"inf_ventanas", nombre:"Ventanas"}, {id:"inf_fachadas", nombre:"Fachadas"}, {id:"inf_avisos", nombre:"Avisos/Pancartas"}] },
  { area: "BAÑOS", items: [{id:"ban_sanitarios", nombre:"Sanitarios"}, {id:"ban_canecas", nombre:"Canecas"}, {id:"ban_lavamanos", nombre:"Lava Manos"}] },
  { area: "LAVADO", items: [{id:"lav_poseta", nombre:"Poseta"}, {id:"lav_traperos", nombre:"Traperos"}, {id:"lav_escobas", nombre:"Escobas"}, {id:"lav_recogedores", nombre:"Recogedores"}, {id:"lav_canecas", nombre:"Baldes"}, {id:"lav_trapos", nombre:"Trapos"}] },
  { area: "BODEGA", items: [{id:"bod_estibas", nombre:"Estibas"}, {id:"bod_gondolas", nombre:"Góndolas"}, {id:"bod_canastillas", nombre:"Canastillas"}, {id:"bod_montacargas", nombre:"Montacargas"}] },
  { area: "EXHIBICIONES", items: [{id:"exh_lineales", nombre:"Lineales"}, {id:"exh_gondolas", nombre:"Góndolas"}, {id:"exh_neveras", nombre:"Neveras"}, {id:"exh_basculas", nombre:"Básculas"}] },
  { area: "CAJA", items: [{id:"caj_comp", nombre:"Computadores"}, {id:"caj_herr", nombre:"Herr. Trabajo"}, {id:"caj_balanza", nombre:"Balanza"}, {id:"caj_mob", nombre:"Mobiliario"}, {id:"caj_term", nombre:"Termómetros"}] },
  { area: "DESCANSO", items: [{id:"des_mesas", nombre:"Mesas"}, {id:"des_sillas", nombre:"Sillas"}, {id:"des_micro", nombre:"Microondas"}, {id:"des_lockers", nombre:"Lockers"}, {id:"des_cart", nombre:"Carteleras"}, {id:"des_filtros", nombre:"Filtros"}] },
  { area: "OTROS", items: [{id:"eco_canecas", nombre:"Ptos Ecológicos"}, {id:"comp_carros", nombre:"Carros Compra"}, {id:"comp_vent", nombre:"Ventiladores"}, {id:"cpe_camaras", nombre:"Cámaras"}, {id:"cpe_elec", nombre:"Sist. Eléctricos"}, {id:"cpe_ext", nombre:"Extintores"}, {id:"cpe_bot", nombre:"Botiquines"}, {id:"cpe_cam", nombre:"Camillas"}, {id:"cpe_sen", nombre:"Señalización"}] }
];

const getAbacHeaders = () => {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("usuario") || localStorage.getItem("user");
  let headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` })
  };
  
  if (userStr) {
    try {
      const parsedUser = JSON.parse(userStr);
      headers['x-user-data'] = JSON.stringify(parsedUser);
      const permisos = parsedUser.permisos_avanzados;
      if (permisos) {
        headers['x-abac-permissions'] = typeof permisos === 'string' ? permisos : JSON.stringify(permisos);
      }
    } catch (e) {
      console.error("Error parseando usuario local para ABAC", e);
    }
  }
  return headers;
};

function SafePortalModal({ children }) {
  const elRef = useRef(null);
  if (!elRef.current && typeof document !== "undefined") {
    const div = document.createElement("div");
    div.setAttribute("data-portal-modal", "true");
    div.setAttribute("translate", "no");
    elRef.current = div;
  }
  useEffect(() => {
    const el = elRef.current;
    if (!el) return;
    document.body.appendChild(el);
    return () => { if (el.parentNode) el.parentNode.removeChild(el); };
  }, []);
  if (!elRef.current) return null;
  return ReactDOM.createPortal(children, elRef.current);
}

const formatearFechaLocal = (fechaString) => {
  if (!fechaString) return "N/A";
  const partes = String(fechaString).split('T')[0].split('-');
  if (partes.length === 3) {
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }
  return fechaString;
};

const obtenerNombreEvaluadoHigiene = (reg) => {
  let resp = typeof reg.respuestas === 'string'
    ? (() => { try { return JSON.parse(reg.respuestas || '{}'); } catch { return {}; } })()
    : (reg.respuestas || {});

  const nombreEvaluado = String(
    reg.empleado_evaluado ||
    resp.empleado_evaluado ||
    resp.nombre_evaluado ||
    resp.colaborador ||
    resp.trabajador ||
    ""
  ).trim().toUpperCase();

  if (nombreEvaluado) return nombreEvaluado;

  const doc = String(reg.documento_evaluado || resp.documento || resp.cedula || "").trim();
  if (doc) return `C.C. ${doc} (SIN NOMBRE EN EMPLEADOS)`;

  return "EMPLEADO SIN IDENTIFICAR";
};

export default function HistorialSST({ usuario, tabInicial, onBack }) {
  const [tabActivo, setTabActivo] = useState(tabInicial || 'INSPECCION_SST');
 
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
  const [tablaMensualSeleccionada, setTablaMensualSeleccionada] = useState(null); 
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [empleadoDetalleHigiene, setEmpleadoDetalleHigiene] = useState(null);

  const cargarHistorial = useCallback(async () => {
    setLoading(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      
      const res = await fetch(`${API_URL}/api/sst/formularios/historial/${encodeURIComponent(tabActivo)}`, {
        method: "GET",
        headers: getAbacHeaders()
      });
      
      if (!res.ok) {
        throw new Error(`Error del servidor: ${res.status}`);
      }
      
      const data = await res.json();
      if (data && data.success) {
        setRegistros(data.data || []);
      } else {
        setRegistros([]);
      }
    } catch (error) {
      console.error("Error cargando historial:", error);
      setRegistros([]);
    } finally {
      setLoading(false);
    }
  }, [tabActivo]); 

  useEffect(() => {
    cargarHistorial();
  }, [cargarHistorial]);

  const abrirDetalleEstandar = async (id) => {
    setLoadingDetalle(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      
      const res = await fetch(`${API_URL}/api/sst/formularios/detalle/${id}`, {
        method: "GET",
        headers: getAbacHeaders()
      });
      
      const data = await res.json();
      if (data.success) {
        setDetalleSeleccionado(data.data);
      } else {
        alert("No se pudo cargar el detalle.");
      }
    } catch (error) {
      console.error("Error al cargar detalle:", error);
    } finally {
      setLoadingDetalle(false);
    }
  };

  const abrirTablaMensual = async (grupo) => {
    setLoadingDetalle(true);
    const ordenados = [...grupo.registros].sort((a,b) => new Date(b.fecha) - new Date(a.fecha));
    const ultimo = ordenados[0];

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      
      const res = await fetch(`${API_URL}/api/sst/formularios/detalle/${ultimo.id}`, {
        method: "GET",
        headers: getAbacHeaders()
      });
      const data = await res.json();
      
      setTablaMensualSeleccionada({
        ...grupo,
        firma_cierre: data.success && data.data.evidencias ? data.data.evidencias.firma_responsable : null,
        evaluador_cierre: data.success ? data.data.evaluador : ultimo.evaluador,
        tipo_reporte: tabActivo
      });
      setEmpleadoDetalleHigiene(null); 
    } catch(e) {
      console.error(e);
      setTablaMensualSeleccionada({ ...grupo, tipo_reporte: tabActivo });
      setEmpleadoDetalleHigiene(null);
    } finally {
      setLoadingDetalle(false);
    }
  };

  const registrosFiltrados = registros.filter(r => {
    const t = String(busqueda || "").toLowerCase();
    const pdv = String(r.pdv_centro || "").toLowerCase();
    const ev = String(r.evaluador || "").toLowerCase();
    const empEval = String(r.empleado_evaluado || "").toLowerCase();
    return pdv.includes(t) || ev.includes(t) || empEval.includes(t);
  });

  let gruposMensuales = [];
  if (['MANEJO_RESIDUOS_SST', 'LIMPIEZA_DESINFECCION_SST', 'PRACTICAS_HIGIENICAS_SST', 'CONTROL_PLAGAS_SST', 'CONTROL_TEMPERATURAS', 'AGUA_POTABLE_SST'].includes(tabActivo)) {
    const agrupados = {};
    registrosFiltrados.forEach(reg => {
      if (!reg.fecha) return;
      const [anio, mes] = String(reg.fecha).split('T')[0].split('-');
      const key = `${reg.pdv_centro}|${anio}-${mes}`;
      if (!agrupados[key]) {
        agrupados[key] = { pdv: reg.pdv_centro, mes: mes, anio: anio, registros: [] };
      }
      agrupados[key].registros.push(reg);
    });
    gruposMensuales = Object.values(agrupados).sort((a, b) => b.anio.localeCompare(a.anio) || b.mes.localeCompare(a.mes));
    
    if (['PRACTICAS_HIGIENICAS_SST', 'CONTROL_PLAGAS_SST', 'CONTROL_TEMPERATURAS'].includes(tabActivo)) {
      gruposMensuales.forEach(grupo => {
        grupo.registros.sort((a, b) => String(a.fecha).localeCompare(String(b.fecha)));
      });
    }
  }

  const renderTablaMensualAguaPotable = (grupo) => {
    if (!grupo?.registros?.length) return null;

    const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];
    const semanasConsolidadas = Array.from({ length: 5 }, (_, i) => ({
      semana: i + 1,
      dias: diasSemana.reduce((acc, dia) => {
        acc[dia] = { sabor: '', olor: '', color: '', materia: '', cloroDato: '', cloro: '', phDato: '', ph: '' };
        return acc;
      }, {})
    }));

    let muestraTomadaDe = '';
    let mantenimientos = [];

    const ordenados = [...grupo.registros].sort((a, b) => new Date(a.fecha) - new Date(b.fecha) || (a.id - b.id));
    ordenados.forEach((reg) => {
      let resp = typeof reg.respuestas === 'string'
        ? (() => { try { return JSON.parse(reg.respuestas || '{}'); } catch { return {}; } })()
        : (reg.respuestas || {});

      const mTomada = String(resp.muestra_tomada_de || resp.muestraTomadaDe || '').trim();
      if (mTomada) muestraTomadaDe = mTomada;

      if (Array.isArray(resp.mantenimientos) && resp.mantenimientos.length > 0) {
        mantenimientos = resp.mantenimientos;
      }

      const listaSem = resp.mediciones || resp.semanas || (Array.isArray(resp) ? resp : []);
      if (!Array.isArray(listaSem)) return;

      listaSem.forEach((semItem, idx) => {
        const numSem = Number(semItem?.semana || idx + 1);
        const destino = semanasConsolidadas[numSem - 1];
        if (!destino || !semItem?.dias) return;

        diasSemana.forEach((dia) => {
          const datosDia = semItem.dias[dia] || (dia === 'Miércoles' ? semItem.dias['Miercoles'] : null);
          if (!datosDia) return;
          Object.entries(datosDia).forEach(([campo, valor]) => {
            if (valor !== undefined && valor !== null && String(valor).trim() !== '') {
              destino.dias[dia][campo] = String(valor).trim();
            }
          });
        });
      });
    });

    return (
      <div className="flex flex-col gap-6 w-full animate-fade-in">
        <div className="bg-sky-50 p-4 rounded-xl border border-sky-200">
          <p className="text-[10px] font-black text-sky-800 uppercase tracking-widest mb-1">Muestra Tomada De</p>
          <p className="text-sm font-bold text-slate-800">{muestraTomadaDe || 'Acueducto / Punto de Muestreo'}</p>
        </div>

        <div className="space-y-6">
          <h3 className="text-sm font-black text-slate-800 uppercase border-b pb-2">Verificación Calidad del Agua</h3>
          {semanasConsolidadas.map((semana, sIdx) => (
            <div key={sIdx} className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
              <div className="bg-sky-600 text-white p-2 font-bold text-center text-xs tracking-widest uppercase">Semana {semana.semana}</div>
              <table className="w-full text-xs text-center border-collapse min-w-[600px]">
                <thead>
                  <tr className="bg-sky-50 border-b border-sky-100">
                    <th className="p-2 border-r border-sky-100 text-left w-48 text-sky-900">Aspecto a Evaluar</th>
                    {diasSemana.map(dia => <th key={dia} className="p-2 border-r border-sky-100 text-sky-900">{dia}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {['sabor', 'olor', 'color', 'materia'].map(campo => (
                    <tr key={campo} className="border-b border-slate-100">
                      <td className="p-2 border-r border-slate-100 font-bold text-left uppercase text-slate-700">{campo === 'materia' ? 'Materia Extraña' : campo}</td>
                      {diasSemana.map(dia => (
                        <td key={dia} className="p-2 border-r border-slate-100 font-bold">
                          {semana.dias[dia]?.[campo] === 'C' ? <span className="text-emerald-600">C</span> : semana.dias[dia]?.[campo] === 'NC' ? <span className="text-red-600">NC</span> : '-'}
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr className="border-b border-slate-100 bg-slate-50">
                    <td className="p-2 border-r border-slate-100 font-bold text-left text-blue-700">Cloro Residual (Dato)</td>
                    {diasSemana.map(dia => <td key={dia} className="p-2 border-r border-slate-100 font-bold text-slate-800">{semana.dias[dia]?.cloroDato || '-'}</td>)}
                  </tr>
                  <tr className="border-b border-slate-100">
                    <td className="p-2 border-r border-slate-100 font-bold text-left text-slate-700">Cloro (C / NC)</td>
                    {diasSemana.map(dia => (
                      <td key={dia} className="p-2 border-r border-slate-100 font-bold">
                        {semana.dias[dia]?.cloro === 'C' ? <span className="text-emerald-600">C</span> : semana.dias[dia]?.cloro === 'NC' ? <span className="text-red-600">NC</span> : '-'}
                      </td>
                    ))}
                  </tr>
                  <tr className="border-b border-slate-100 bg-slate-50">
                    <td className="p-2 border-r border-slate-100 font-bold text-left text-green-700">PH (Dato)</td>
                    {diasSemana.map(dia => <td key={dia} className="p-2 border-r border-slate-100 font-bold text-slate-800">{semana.dias[dia]?.phDato || '-'}</td>)}
                  </tr>
                  <tr className="border-b border-slate-100">
                    <td className="p-2 border-r border-slate-100 font-bold text-left text-slate-700">PH (C / NC)</td>
                    {diasSemana.map(dia => (
                      <td key={dia} className="p-2 border-r border-slate-100 font-bold">
                        {semana.dias[dia]?.ph === 'C' ? <span className="text-emerald-600">C</span> : semana.dias[dia]?.ph === 'NC' ? <span className="text-red-600">NC</span> : '-'}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        </div>

        <div className="mt-4">
          <h3 className="text-sm font-black text-slate-800 uppercase border-b pb-2 mb-4">Mantenimiento, Lavado y Desinfección</h3>
          {mantenimientos.length === 0 ? (
            <div className="text-center py-6 bg-slate-50 rounded-xl border border-dashed border-slate-300">
              <p className="text-xs font-bold text-slate-500">No hay mantenimientos registrados este mes.</p>
            </div>
          ) : (
            <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
              <table className="w-full text-left border-collapse min-w-[600px]">
                <thead>
                  <tr className="bg-sky-600 text-white text-[9px] uppercase tracking-wider text-center">
                    <th className="p-2 border-r border-sky-500/50">Elemento</th>
                    <th className="p-2 border-r border-sky-500/50">Fecha</th>
                    <th className="p-2 border-r border-sky-500/50">Descripción</th>
                    <th className="p-2">Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  {mantenimientos.map((mant, mIdx) => (
                    <tr key={mIdx} className="border-b border-slate-200 hover:bg-sky-50 text-xs text-center">
                      <td className="p-2 border-r border-slate-200 font-bold text-slate-700">{mant.elemento || '-'}</td>
                      <td className="p-2 border-r border-slate-200">{formatearFechaLocal(mant.fecha) || '-'}</td>
                      <td className="p-2 border-r border-slate-200 text-slate-600">{mant.descripcion || '-'}</td>
                      <td className="p-2 text-slate-600">{mant.observaciones || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderFilasMensualesResiduos = (grupo) => {
    const diasDelMes = new Date(grupo.anio, grupo.mes, 0).getDate();
    const filas = [];
    let sumaTotalKg = 0;

    for (let i = 1; i <= diasDelMes; i++) {
      const fechaBuscada = `${grupo.anio}-${grupo.mes}-${String(i).padStart(2, '0')}`;
      const registroDia = grupo.registros.find(r => String(r.fecha).startsWith(fechaBuscada));
      
      let papel='', carton='', plastico='', vidrio='', latas='', otros='', cantidad='', entregado='';
      
      if (registroDia) {
        let resp = typeof registroDia.respuestas === 'string' ? JSON.parse(registroDia.respuestas || '{}') : (registroDia.respuestas || {});
        const residuosStr = resp.residuos_generados ? String(resp.residuos_generados).toUpperCase() : "";
        if (residuosStr.includes("PAPEL")) papel = 'X';
        if (residuosStr.includes("CARTON")) carton = 'X';
        if (residuosStr.includes("PLASTICO")) plastico = 'X';
        if (residuosStr.includes("VIDRIO")) vidrio = 'X';
        if (residuosStr.includes("LATAS")) latas = 'X';
        if (residuosStr.includes("OTROS")) otros = 'X';
        
        cantidad = Number(resp.cantidad_kg) || 0;
        sumaTotalKg += cantidad;
        entregado = resp.entregado_a || '';
      }

      filas.push(
        <tr key={i} className={`text-center border-b border-slate-200 ${registroDia ? 'bg-emerald-50/50' : 'bg-white'} hover:bg-emerald-100/30 transition-colors`}>
          <td className="p-1.5 sm:p-2 font-bold text-slate-700 text-[10px] sm:text-xs">{i}</td>
          <td className="p-1.5 sm:p-2 text-emerald-600 font-black text-xs">{papel}</td>
          <td className="p-1.5 sm:p-2 text-emerald-600 font-black text-xs">{carton}</td>
          <td className="p-1.5 sm:p-2 text-emerald-600 font-black text-xs">{plastico}</td>
          <td className="p-1.5 sm:p-2 text-emerald-600 font-black text-xs">{vidrio}</td>
          <td className="p-1.5 sm:p-2 text-emerald-600 font-black text-xs">{latas}</td>
          <td className="p-1.5 sm:p-2 text-emerald-600 font-black text-xs">{otros}</td>
          <td className="p-1.5 sm:p-2 font-black text-slate-800 text-[10px] sm:text-xs">{cantidad ? cantidad : ''}</td>
          <td className="p-1.5 sm:p-2 text-[9px] sm:text-[10px] text-slate-600 font-bold uppercase truncate max-w-[80px]">{entregado}</td>
        </tr>
      );
    }
    return { filas, sumaTotalKg };
  };

  const renderTablaMensualLimpieza = (grupo) => {
    const diasDelMes = new Date(grupo.anio, grupo.mes, 0).getDate();
    const filas = [];

    CATEGORIAS_LIMPIEZA_ESTRUCTURA.forEach((cat) => {
      cat.items.forEach((item, itemIndex) => {
        const celdasDias = [];
        
        for (let d = 1; d <= diasDelMes; d++) {
          const fechaBuscada = `${grupo.anio}-${grupo.mes}-${String(d).padStart(2, '0')}`;
          const registroDia = grupo.registros.find(r => String(r.fecha).startsWith(fechaBuscada));
          
          let valorCelda = "";
          let claseColor = "text-slate-300";

          if (registroDia) {
            let resp = typeof registroDia.respuestas === 'string' ? JSON.parse(registroDia.respuestas || '{}') : (registroDia.respuestas || {});
            const marcado = resp[item.id];
            if (marcado === 'SI') { valorCelda = "✓"; claseColor = "text-emerald-500 font-black"; }
            else if (marcado === 'NO') { valorCelda = "X"; claseColor = "text-red-500 font-black"; }
            else if (marcado === 'N/A') { valorCelda = "-"; claseColor = "text-slate-500 font-bold"; }
          }
          
          celdasDias.push(
            <td key={d} className={`border border-slate-200 p-1 text-[10px] text-center ${registroDia ? 'bg-cyan-50/30' : ''} ${claseColor}`}>
              {valorCelda}
            </td>
          );
        }

        filas.push(
          <tr key={`${cat.area}-${item.id}`} className="hover:bg-cyan-50/50">
            {itemIndex === 0 && (
              <td rowSpan={cat.items.length} className="border border-slate-200 p-1 text-[9px] font-black text-slate-600 uppercase bg-slate-50 rotate-180 md:rotate-0 align-middle text-center w-10 md:w-auto">
                <div className="md:writing-mode-horizontal writing-mode-vertical whitespace-nowrap md:whitespace-normal leading-tight">{cat.area}</div>
              </td>
            )}
            <td className="border border-slate-200 p-1 px-2 text-[9px] font-bold text-slate-800 uppercase whitespace-nowrap min-w-[120px]">
              {item.nombre}
            </td>
            {celdasDias}
          </tr>
        );
      });
    });

    return filas;
  };

  const renderResumenHigiene = (grupo) => {
    const empMap = {};
    grupo.registros.forEach(reg => {
      let resp = typeof reg.respuestas === 'string'
        ? (() => { try { return JSON.parse(reg.respuestas || '{}'); } catch { return {}; } })()
        : (reg.respuestas || {});

      const nombreEvaluado = obtenerNombreEvaluadoHigiene(reg);
      const cargoEvaluado = String(reg.cargo_evaluado && reg.cargo_evaluado !== 'N/A' ? reg.cargo_evaluado : (resp.cargo || 'SIN CARGO')).toUpperCase();
      const docEvaluado = String(reg.documento_evaluado || resp.documento || "").trim();

      if (!empMap[nombreEvaluado]) {
        empMap[nombreEvaluado] = {
          nombre: nombreEvaluado,
          documento: docEvaluado,
          cargo: cargoEvaluado,
          evaluacionesTotales: 0,
          diasPerfectos: 0,
          diasConFallos: 0
        };
      }
      if ((empMap[nombreEvaluado].cargo === 'SIN CARGO' || empMap[nombreEvaluado].cargo === 'N/A') && cargoEvaluado !== 'SIN CARGO') {
        empMap[nombreEvaluado].cargo = cargoEvaluado;
      }

      empMap[nombreEvaluado].evaluacionesTotales++;

      const esMujer = String(resp.genero || '').toUpperCase() === 'MUJER';
      const camposEvaluados = esMujer
        ? ['cabello', 'maquillaje', 'unas', 'joyas', 'dotacion', 'locion', 'heridas']
        : ['cabello', 'joyas', 'barba', 'dotacion', 'locion', 'heridas', 'unas'];

      const tieneAlgunNo = camposEvaluados.some(campo => {
        const val = String(resp[campo] ?? '').trim().toUpperCase();
        return val === 'NO' || val === 'FALSE' || val === '0';
      });

      const textoAccion = String(resp.accion_correctiva || '').trim();
      const tieneAccionCorrectiva = Boolean(textoAccion) && textoAccion !== '-' && textoAccion.toUpperCase() !== 'N/A' && textoAccion.toUpperCase() !== 'NINGUNA';

      if (tieneAlgunNo || tieneAccionCorrectiva) {
        empMap[nombreEvaluado].diasConFallos++;
      } else {
        empMap[nombreEvaluado].diasPerfectos++;
      }
    });

    const resumen = Object.values(empMap).sort((a,b) => a.nombre.localeCompare(b.nombre));

    return resumen.map((emp, index) => (
      <tr key={index} className={`text-center border-b border-slate-200 hover:bg-fuchsia-50/50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}`}>
        <td className="p-3 border-r border-slate-200 text-xs font-black text-slate-800 uppercase text-left">
          <div>{emp.nombre}</div>
          {emp.documento && <span className="text-[10px] font-bold text-slate-400">C.C. {emp.documento}</span>}
        </td>
        <td className="p-3 border-r border-slate-200 text-[10px] font-bold text-slate-500 uppercase">{emp.cargo}</td>
        <td className="p-3 border-r border-slate-200 text-sm font-black text-fuchsia-700">{emp.evaluacionesTotales}</td>
        <td className="p-3 border-r border-slate-200 text-sm font-black text-emerald-600">{emp.diasPerfectos}</td>
        <td className="p-3 border-r border-slate-200 text-sm font-black text-red-500">{emp.diasConFallos > 0 ? emp.diasConFallos : '0'}</td>
        <td className="p-3">
          <button onClick={() => setEmpleadoDetalleHigiene(emp.nombre)} className="bg-fuchsia-100 text-fuchsia-700 hover:bg-fuchsia-600 hover:text-white px-3 py-1.5 rounded-lg text-[10px] font-black transition-all shadow-sm border border-fuchsia-200 uppercase tracking-widest w-full cursor-pointer">
            Ver Detalle
          </button>
        </td>
      </tr>
    ));
  };
  
  const renderDetalleDiarioEmpleadoHigiene = (registrosEmpleado) => {
    return registrosEmpleado.map((reg, index) => {
      let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
      const esMujer = String(resp.genero || '').toUpperCase() === 'MUJER';
      const v = (val) => val === 'SI' ? <span className="text-emerald-500 font-black text-sm">✓</span> : val === 'NO' ? <span className="text-red-500 font-black text-sm">X</span> : <span className="text-slate-300">-</span>;

      return (
        <tr key={reg.id} className={`text-center border-b border-slate-200 hover:bg-fuchsia-50/30 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}`}>
          <td className="p-2 border-r border-slate-200 text-[10px] font-bold text-slate-800 whitespace-nowrap bg-fuchsia-50/20">{formatearFechaLocal(reg.fecha)}</td>
          <td className="p-2 border-r border-slate-200 text-[10px] font-bold text-slate-600 whitespace-nowrap">{resp.turno || '-'}</td>
          <td className="p-2 border-r border-slate-200 text-[10px] font-bold text-slate-700 whitespace-nowrap">{reg.evaluador || '-'}</td>
          
          <td className="p-2 border-r border-slate-200">{esMujer ? v(resp.cabello) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{esMujer ? v(resp.maquillaje) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{esMujer ? v(resp.unas) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{esMujer ? v(resp.joyas) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{esMujer ? v(resp.dotacion) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{esMujer ? v(resp.locion) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 bg-slate-100 border-r-2 border-slate-300">{esMujer ? v(resp.heridas) : <span className="text-slate-300">-</span>}</td>
          
          <td className="p-2 border-r border-slate-200">{!esMujer ? v(resp.cabello) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{!esMujer ? v(resp.joyas) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{!esMujer ? v(resp.barba) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{!esMujer ? v(resp.dotacion) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{!esMujer ? v(resp.locion) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 border-r border-slate-200">{!esMujer ? v(resp.heridas) : <span className="text-slate-300">-</span>}</td>
          <td className="p-2 bg-slate-100 border-r-2 border-slate-300">{!esMujer ? v(resp.unas) : <span className="text-slate-300">-</span>}</td>
          
          <td className="p-2 text-[10px] text-red-600 font-bold max-w-[200px] truncate text-left" title={resp.accion_correctiva}>{resp.accion_correctiva || '-'}</td>
        </tr>
      );
    });
  };

  const renderTablaMensualPlagas = (grupo) => {
    return grupo.registros.map((reg, index) => {
      let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
      const hayPlaga = resp.tipo_plaga !== "NINGUNA";

      return (
        <tr key={reg.id} className={`text-center border-b border-slate-200 hover:bg-violet-50/50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}`}>
          <td className="p-3 border-r border-slate-200 text-xs font-bold text-slate-800 whitespace-nowrap bg-violet-50/20">{formatearFechaLocal(reg.fecha)}</td>
          <td className="p-3 border-r border-slate-200 text-xs font-bold text-slate-600">{resp.turno}</td>
          <td className={`p-3 border-r border-slate-200 text-xs font-black uppercase ${hayPlaga ? 'text-rose-600 bg-rose-50/50' : 'text-emerald-600'}`}>{resp.tipo_plaga}</td>
          <td className="p-3 border-r border-slate-200 text-[10px] font-bold text-slate-700 uppercase">{resp.ubicacion}</td>
          <td className="p-3 border-r border-slate-200 text-[10px] font-bold text-slate-700 uppercase">{resp.evidencia}</td>
          <td className="p-3 border-r border-slate-200 text-[10px] font-black text-slate-800 uppercase">{reg.evaluador}</td>
          <td className="p-3 text-[10px] text-rose-600 font-bold max-w-[250px] truncate text-left" title={resp.accion_correctiva}>{resp.accion_correctiva || '-'}</td>
        </tr>
      );
    });
  };

  const renderTablaMensualTemperaturas = (grupo) => {
    const fmtT = (val, min, max, esMenorIgual = false, esMayorIgual = false) => {
      if (val === undefined || val === null || val === "") return <span className="text-slate-300">-</span>;
      const num = parseFloat(val);
      if (isNaN(num)) return <span className="text-slate-300">-</span>;

      let esCorrecto = true;
      if (esMenorIgual) esCorrecto = num <= max;
      else if (esMayorIgual) esCorrecto = num >= min;
      else esCorrecto = num >= min && num <= max;

      return (
        <span className={`font-black text-xs px-1.5 py-0.5 rounded ${esCorrecto ? 'text-emerald-700 bg-emerald-50' : 'text-rose-700 bg-rose-100 border border-rose-300'}`}>
          {num}°C
        </span>
      );
    };

    return grupo.registros.map((reg, index) => {
      let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});

      return (
        <tr key={reg.id} className={`text-center border-b border-slate-200 hover:bg-cyan-50/40 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}`}>
          <td className="p-2 border-r border-slate-200 text-xs font-bold text-slate-800 whitespace-nowrap bg-cyan-50/20">{formatearFechaLocal(reg.fecha)}</td>
          <td className="p-2 border-r border-slate-200 text-[10px] font-bold text-slate-600 whitespace-nowrap">{resp.turno}</td>
          
          <td className="p-2 border-r border-slate-200">{fmtT(resp.ref_lacteos, 2, 6)}</td>
          <td className="p-2 border-r border-slate-200">{fmtT(resp.ref_pesca, 0, 4)}</td>
          <td className="p-2 border-r border-slate-200">{fmtT(resp.ref_carnes, 0, 6)}</td>
          <td className="p-2 border-r border-slate-200">{fmtT(resp.ref_preparados, 2, 6)}</td>
          <td className="p-2 border-r border-slate-200 font-bold text-xs text-slate-700">{resp.ref_bebidas ? `${resp.ref_bebidas}°C` : '-'}</td>
          
          <td className="p-2 border-r border-slate-200 bg-blue-50/30">{fmtT(resp.con_pesca, -99, -18, true)}</td>
          <td className="p-2 border-r border-slate-200 bg-blue-50/30">{fmtT(resp.con_carnes, -99, -18, true)}</td>
          
          <td className="p-2 border-r border-slate-200 bg-orange-50/30">{fmtT(resp.cal_preparados, 60, 999, false, true)}</td>
          
          <td className="p-2 border-r border-slate-200 text-[10px] font-black text-slate-800 uppercase">{reg.evaluador}</td>
          <td className="p-2 text-[10px] text-slate-600 font-medium max-w-[200px] truncate text-left" title={resp.observaciones}>{resp.observaciones || '-'}</td>
        </tr>
      );
    });
  };

  return (
    <div className="bg-white/20 backdrop-blur-3xl rounded-2xl sm:rounded-[34px] shadow-2xl max-w-6xl w-full mx-auto border border-white/30 animate-fade-in relative h-[90vh] overflow-hidden flex flex-col">
      
      {/* CABECERA GENERAL */}
      <div className="bg-transparent border-b border-white/20 px-4 py-3 sm:px-8 sm:py-5 z-40 flex flex-col sm:flex-row items-center justify-between gap-4 shrink-0">
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <button onClick={onBack} className="w-10 h-10 flex-none bg-white/60 hover:bg-white/80 text-slate-700 hover:text-blue-600 flex items-center justify-center rounded-full transition-all shadow-sm border border-white/40 cursor-pointer backdrop-blur-sm">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7"></path></svg>
          </button>
          <div>
            <h1 className="text-lg sm:text-xl font-black text-slate-800 leading-tight">Auditoría SST</h1>
            <p className="text-[11px] font-bold text-slate-600 mt-0.5">Historial y trazabilidad documental</p>
          </div>
        </div>
        <div className="w-full sm:w-80 relative">
          <input type="text" placeholder="Buscar por Sede o Usuario..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} className="w-full bg-white/60 backdrop-blur-md border border-white/60 rounded-xl px-4 py-2 text-xs font-semibold text-slate-800 outline-none focus:border-blue-400 focus:bg-white shadow-sm transition-all pl-9 placeholder:text-slate-400" />
          <span className="absolute left-3 top-2.5 text-slate-400">🔍</span>
        </div>
      </div>

      <div className="flex px-4 sm:px-8 pt-4 gap-2 border-b border-white/20 shrink-0 overflow-x-auto no-scrollbar">
        <button onClick={() => setTabActivo('INSPECCION_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'INSPECCION_SST' ? 'bg-blue-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>📋 Inspecciones</button>
        <button onClick={() => setTabActivo('AGUA_POTABLE_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'AGUA_POTABLE_SST' ? 'bg-sky-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>💧 Agua Potable</button>
        <button onClick={() => setTabActivo('CONTROL_TEMPERATURAS')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'CONTROL_TEMPERATURAS' ? 'bg-cyan-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>❄️ Temperaturas</button>
        <button onClick={() => setTabActivo('LIMPIEZA_DESINFECCION_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'LIMPIEZA_DESINFECCION_SST' ? 'bg-blue-500 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>✨ Limpieza</button>
        <button onClick={() => setTabActivo('PRACTICAS_HIGIENICAS_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'PRACTICAS_HIGIENICAS_SST' ? 'bg-fuchsia-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>🧴 Higiene</button>
        <button onClick={() => setTabActivo('CONTROL_PLAGAS_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'CONTROL_PLAGAS_SST' ? 'bg-violet-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>🐀 Plagas</button>
        <button onClick={() => setTabActivo('MANEJO_RESIDUOS_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'MANEJO_RESIDUOS_SST' ? 'bg-emerald-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>♻️ Residuos</button>
        <button onClick={() => setTabActivo('MANTENIMIENTO_EQUIPOS_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? 'bg-orange-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>🔧 Mtto Equipos</button>
        <button onClick={() => setTabActivo('AUTOREPORTE_SALUD')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'AUTOREPORTE_SALUD' ? 'bg-indigo-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>🩺 Salud</button>
        <button onClick={() => setTabActivo('REPORTE_INCIDENTES_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'REPORTE_INCIDENTES_SST' ? 'bg-amber-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>⚠️ Incidentes</button>
        <button onClick={() => setTabActivo('CONTROL_LIMPIEZA_BANOS_SST')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'bg-teal-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>🧽 Baños</button>
        <button onClick={() => setTabActivo('ACCION_CORRECTIVA_MP')} className={`px-4 py-2 text-[10px] sm:text-xs font-black uppercase tracking-wider rounded-t-xl transition-all whitespace-nowrap ${tabActivo === 'ACCION_CORRECTIVA_MP' ? 'bg-rose-600 text-white shadow-md' : 'bg-white/40 text-slate-600 hover:bg-white/60'}`}>⛔ Rechazos</button>
      </div>

      <div className="flex-1 overflow-y-auto p-3 sm:p-8 space-y-3 custom-scrollbar">
        {loading ? (
          <div className="text-center py-20"><span className="text-4xl animate-bounce inline-block mb-2">⏳</span><p className="text-sm font-bold text-slate-600">Cargando registros...</p></div>
        ) : ['MANEJO_RESIDUOS_SST', 'LIMPIEZA_DESINFECCION_SST', 'PRACTICAS_HIGIENICAS_SST', 'CONTROL_PLAGAS_SST', 'CONTROL_TEMPERATURAS', 'AGUA_POTABLE_SST'].includes(tabActivo) ? (
          gruposMensuales.length === 0 ? (
            <div className="text-center py-20 bg-white/30 backdrop-blur-md rounded-2xl border border-dashed border-white/50 shadow-inner"><span className="text-4xl mb-2 block grayscale opacity-50">📭</span><p className="text-sm font-bold text-slate-600">No hay registros mensuales.</p></div>
          ) : (
            gruposMensuales.map((grupo, index) => {
              const nombreMes = NOMBRES_MESES[parseInt(grupo.mes, 10) - 1];
              const colorTema = tabActivo === 'AGUA_POTABLE_SST' ? 'sky' : tabActivo === 'CONTROL_TEMPERATURAS' ? 'cyan' : tabActivo === 'LIMPIEZA_DESINFECCION_SST' ? 'blue' : tabActivo === 'PRACTICAS_HIGIENICAS_SST' ? 'fuchsia' : tabActivo === 'CONTROL_PLAGAS_SST' ? 'violet' : 'emerald';
              
              return (
                <div key={index} className={`bg-white/60 backdrop-blur-md hover:bg-white/80 p-5 rounded-2xl shadow-sm transition-all flex flex-col md:flex-row md:items-center justify-between gap-4 group border border-${colorTema}-200/50`}>
                  <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 rounded-xl flex flex-col items-center justify-center shadow-inner border shrink-0 bg-${colorTema}-100 text-${colorTema}-600 border-${colorTema}-200`}>
                      <span className="text-xl">{tabActivo === 'AGUA_POTABLE_SST' ? '💧' : tabActivo === 'CONTROL_TEMPERATURAS' ? '❄️' : tabActivo === 'PRACTICAS_HIGIENICAS_SST' ? '👥' : tabActivo === 'CONTROL_PLAGAS_SST' ? '🐀' : '📅'}</span>
                    </div>
                    <div>
                      <span className={`bg-${colorTema}-600 text-white text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wider shadow-sm mb-1 inline-block`}>Reporte Mensual</span>
                      <h3 className="text-sm font-black text-slate-800 uppercase tracking-tight">{grupo.pdv}</h3>
                      <p className="text-xs font-bold text-slate-500 mt-0.5">{nombreMes} {grupo.anio} • <span className={`text-${colorTema}-600`}>{grupo.registros.length} registros</span></p>
                    </div>
                  </div>
                  <button 
                    onClick={() => abrirTablaMensual(grupo)}
                    disabled={loadingDetalle}
                    className={`bg-${colorTema}-600 hover:bg-${colorTema}-500 border-${colorTema}-400/50 text-white px-5 py-2.5 rounded-xl text-xs font-black transition-all shadow-md active:scale-95 cursor-pointer border w-full md:w-auto`}
                  >
                    {loadingDetalle ? "Cargando..." : "VER REPORTE MENSUAL"}
                  </button>
                </div>
              );
            })
          )
        ) : (
          registrosFiltrados.length === 0 ? (
            <div className="text-center py-20 bg-white/30 backdrop-blur-md rounded-2xl border border-dashed border-white/50 shadow-inner"><span className="text-4xl mb-2 block grayscale opacity-50">📭</span><p className="text-sm font-bold text-slate-600">No hay registros para esta categoría.</p></div>
          ) : (
            registrosFiltrados.map((reg) => (
              <div key={reg.id} className="bg-white/50 backdrop-blur-md hover:bg-white/70 p-4 rounded-2xl border border-white/60 shadow-sm transition-all flex flex-col md:flex-row md:items-center justify-between gap-4 group">
                <div className="flex items-center gap-4">
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center text-xs font-black shrink-0 shadow-inner border ${
                    tabActivo === 'INSPECCION_SST' 
                      ? (reg.puntaje_global >= 90 ? 'bg-emerald-100/80 text-emerald-700 border-emerald-200' : reg.puntaje_global >= 70 ? 'bg-yellow-100/80 text-yellow-700 border-yellow-200' : 'bg-red-100/80 text-red-700 border-red-200')
                      : tabActivo === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'bg-teal-100/80 text-teal-700 border-teal-200 text-2xl' 
                      : tabActivo === 'AUTOREPORTE_SALUD' ? 'bg-indigo-100/80 text-indigo-700 border-indigo-200 text-2xl' 
                      : tabActivo === 'ACCION_CORRECTIVA_MP' ? 'bg-rose-100/80 text-rose-700 border-rose-200 text-2xl'
                      : tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? 'bg-orange-100/80 text-orange-700 border-orange-200 text-2xl'
                      : 'bg-amber-100/80 text-amber-700 border-amber-200 text-2xl'
                  }`}>
                    {tabActivo === 'INSPECCION_SST' ? `${Number(reg.puntaje_global).toFixed(0)}%` : tabActivo === 'CONTROL_LIMPIEZA_BANOS_SST' ? '🧽' : tabActivo === 'AUTOREPORTE_SALUD' ? '🩺' : tabActivo === 'ACCION_CORRECTIVA_MP' ? '⛔' : tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? '🔧' : '⚠️'}
                  </div>
                  <div>
                    <span className={`${tabActivo === 'INSPECCION_SST' ? 'bg-blue-600' : tabActivo === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'bg-teal-600' : tabActivo === 'AUTOREPORTE_SALUD' ? 'bg-indigo-600' : tabActivo === 'ACCION_CORRECTIVA_MP' ? 'bg-rose-600' : tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? 'bg-orange-600' : 'bg-amber-600'} text-white text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-wider shadow-sm mb-1 inline-block`}>
                      {tabActivo === 'INSPECCION_SST' ? 'Inspección' : tabActivo === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'Limpieza Baño' : tabActivo === 'AUTOREPORTE_SALUD' ? 'Salud' : tabActivo === 'ACCION_CORRECTIVA_MP' ? 'Rechazo' : tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? 'Mantenimiento' : 'Incidente'}
                    </span>
                    <h3 className="text-sm font-black text-slate-800 uppercase tracking-tight">
                      {tabActivo === 'AUTOREPORTE_SALUD' ? (
                        (() => {
                          let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
                          let nombre = resp.nombres || '';
                          let apellido = resp.apellidos || '';
                          let nombreCompleto = `${nombre} ${apellido}`.replace(/undefined/ig, '').trim();
                          return nombreCompleto ? nombreCompleto : reg.pdv_centro;
                        })()
                      ) : tabActivo === 'ACCION_CORRECTIVA_MP' ? (
                        (() => {
                          let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
                          let producto = resp.producto || 'Producto';
                          let lote = resp.lote ? ` • Lote: ${resp.lote}` : '';
                          return `${producto}${lote}`;
                        })()
                      ) : tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? (
                        (() => {
                          let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
                          return `${resp.tipoEquipo || 'Equipo'} - ${resp.marcaEquipo || 'Sin Marca'}`;
                        })()
                      ) : reg.pdv_centro}
                    </h3>
                    <p className="text-[11px] font-bold text-slate-600 mt-0.5">
                      {tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? (
                        (() => {
                          let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
                          return <>Técnico: <span className="text-slate-800">{resp.nombreTecnico || 'N/A'}</span> • Empresa: <span className="text-slate-800">{resp.empresaProveedor || 'N/A'}</span> • Sede: {reg.pdv_centro}</>;
                        })()
                      ) : tabActivo === 'ACCION_CORRECTIVA_MP' ? (
                        (() => {
                          let resp = typeof reg.respuestas === 'string' ? JSON.parse(reg.respuestas || '{}') : (reg.respuestas || {});
                          let proveedor = resp.proveedor ? `Proveedor: ${resp.proveedor} • ` : '';
                          let responsable = reg.evaluador ? `Responsable: ${reg.evaluador}` : '';
                          return <>{proveedor}{responsable} • Sede: <span className="text-slate-800">{reg.pdv_centro}</span></>;
                        })()
                      ) : (
                        <>Sede/Área: <span className="text-slate-800">{reg.pdv_centro}</span></>
                      )}
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between md:justify-end gap-6 w-full md:w-auto">
                  <div className="text-left md:text-right">
                    <p className="text-[9px] uppercase tracking-widest font-black text-slate-500">Fecha del Registro</p>
                    <p className="text-xs font-bold text-slate-700">{formatearFechaLocal(reg.fecha)}</p>
                  </div>
                  <button onClick={() => abrirDetalleEstandar(reg.id)} disabled={loadingDetalle} className={`${tabActivo === 'INSPECCION_SST' ? 'bg-blue-600 hover:bg-blue-500' : tabActivo === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'bg-teal-600 hover:bg-teal-500' : tabActivo === 'AUTOREPORTE_SALUD' ? 'bg-indigo-600 hover:bg-indigo-500' : tabActivo === 'ACCION_CORRECTIVA_MP' ? 'bg-rose-600 hover:bg-rose-500' : tabActivo === 'MANTENIMIENTO_EQUIPOS_SST' ? 'bg-orange-600 hover:bg-orange-500' : 'bg-amber-600 hover:bg-amber-500'} text-white px-4 py-2.5 rounded-xl text-xs font-black transition-all shadow-md active:scale-95 cursor-pointer border`}>
                    {loadingDetalle ? "Cargando..." : "VER DETALLE"}
                  </button>
                </div>
              </div>
            ))
          )
        )}
      </div>

      {tablaMensualSeleccionada && (
        <SafePortalModal>
          <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-md flex justify-center items-center p-2 sm:p-4 z-[99999] animate-fade-in">
            <div className="bg-white/95 backdrop-blur-3xl rounded-[24px] sm:rounded-[32px] p-4 sm:p-8 max-w-[1280px] w-full shadow-2xl border border-white flex flex-col my-auto relative overflow-hidden" style={{ maxHeight: '95vh' }}>
              
              <div className="flex justify-between items-center border-b border-slate-200 pb-4 mb-4 shrink-0">
                <div>
                  <span className={`${tablaMensualSeleccionada.tipo_reporte === 'AGUA_POTABLE_SST' ? 'bg-sky-100 text-sky-800' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_TEMPERATURAS' ? 'bg-cyan-100 text-cyan-800' : tablaMensualSeleccionada.tipo_reporte === 'LIMPIEZA_DESINFECCION_SST' ? 'bg-blue-100 text-blue-800' : tablaMensualSeleccionada.tipo_reporte === 'PRACTICAS_HIGIENICAS_SST' ? 'bg-fuchsia-100 text-fuchsia-800' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_PLAGAS_SST' ? 'bg-violet-100 text-violet-800' : 'bg-emerald-100 text-emerald-800'} text-[10px] font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider`}>
                    {tablaMensualSeleccionada.tipo_reporte === 'AGUA_POTABLE_SST' ? 'REPORTE FT-CD-08' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_TEMPERATURAS' ? 'REPORTE FT-CD-02' : tablaMensualSeleccionada.tipo_reporte === 'LIMPIEZA_DESINFECCION_SST' ? 'REPORTE FT-SST-08' : tablaMensualSeleccionada.tipo_reporte === 'PRACTICAS_HIGIENICAS_SST' ? 'REPORTE FT-CD-01' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_PLAGAS_SST' ? 'REPORTE FT-CD-05' : 'REPORTE FT-SST-09'}
                  </span>
                  <h2 className="text-sm sm:text-lg font-black text-slate-900 uppercase mt-1">
                    {tablaMensualSeleccionada.tipo_reporte === 'AGUA_POTABLE_SST' ? 'Programa Abastecimiento de Agua Potable' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_TEMPERATURAS' ? 'Control de Temperaturas (INVIMA)' : tablaMensualSeleccionada.tipo_reporte === 'LIMPIEZA_DESINFECCION_SST' ? 'Control de Limpieza y Desinfección' : tablaMensualSeleccionada.tipo_reporte === 'PRACTICAS_HIGIENICAS_SST' ? 'Prácticas Higiénicas' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_PLAGAS_SST' ? 'Control de Plagas' : 'Manejo de Residuos Sólidos'}
                  </h2>
                  <p className="text-xs text-slate-500 font-bold mt-1">
                    PDV: <span className="text-slate-800">{tablaMensualSeleccionada.pdv}</span> | 
                    Mes: <span className={tablaMensualSeleccionada.tipo_reporte === 'AGUA_POTABLE_SST' ? 'text-sky-700' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_TEMPERATURAS' ? 'text-cyan-700' : tablaMensualSeleccionada.tipo_reporte === 'LIMPIEZA_DESINFECCION_SST' ? 'text-blue-700' : tablaMensualSeleccionada.tipo_reporte === 'PRACTICAS_HIGIENICAS_SST' ? 'text-fuchsia-700' : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_PLAGAS_SST' ? 'text-violet-700' : 'text-emerald-700'}>
                      {NOMBRES_MESES[parseInt(tablaMensualSeleccionada.mes, 10) - 1]} {tablaMensualSeleccionada.anio}
                    </span>
                  </p>
                </div>
                <button onClick={() => { setTablaMensualSeleccionada(null); setEmpleadoDetalleHigiene(null); }} className="w-8 h-8 bg-slate-100 hover:bg-red-100 hover:text-red-600 text-slate-600 rounded-full flex items-center justify-center font-black transition-colors shadow-inner shrink-0 cursor-pointer">✕</button>
              </div>

              <div className="overflow-y-auto flex-1 pb-4 custom-scrollbar">
                {tablaMensualSeleccionada.tipo_reporte === 'AGUA_POTABLE_SST' ? (
                   renderTablaMensualAguaPotable(tablaMensualSeleccionada)
                ) : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_TEMPERATURAS' ? (
                  <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
                    <table className="w-full text-left border-collapse min-w-[1100px]">
                      <thead>
                        <tr className="bg-cyan-700 text-white text-[9px] uppercase tracking-wider text-center">
                          <th className="p-2 border-r border-cyan-600/50" rowSpan="2">FECHA</th>
                          <th className="p-2 border-r border-cyan-600/50" rowSpan="2">TURNO</th>
                          <th className="p-1 border-r border-cyan-600/50 border-b bg-cyan-800/80" colSpan="5">❄️ REFRIGERACIÓN</th>
                          <th className="p-1 border-r border-cyan-600/50 border-b bg-blue-800/80" colSpan="2">🧊 CONGELACIÓN</th>
                          <th className="p-1 border-r border-cyan-600/50 border-b bg-orange-700/80">🔥 CALIENTE</th>
                          <th className="p-2 border-r border-cyan-600/50" rowSpan="2">RESPONSABLE</th>
                          <th className="p-2" rowSpan="2">OBSERVACIONES / ACCIÓN CORRECTIVA</th>
                        </tr>
                        <tr className="bg-cyan-800 text-white text-[8px] font-bold text-center">
                          <th className="p-1 border-r border-cyan-600/50">Lácteos<br/>(2-6°C)</th>
                          <th className="p-1 border-r border-cyan-600/50">Pesca<br/>(0-4°C)</th>
                          <th className="p-1 border-r border-cyan-600/50">Carnes<br/>(0-6°C)</th>
                          <th className="p-1 border-r border-cyan-600/50">Prep.<br/>(2-6°C)</th>
                          <th className="p-1 border-r border-cyan-600/50">Bebidas</th>
                          <th className="p-1 border-r border-cyan-600/50 bg-blue-900/60">Pesca<br/>(≤ -18°C)</th>
                          <th className="p-1 border-r border-cyan-600/50 bg-blue-900/60">Carnes<br/>(≤ -18°C)</th>
                          <th className="p-1 border-r border-cyan-600/50 bg-orange-800/60">Prep.<br/>(≥ 60°C)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderTablaMensualTemperaturas(tablaMensualSeleccionada)}
                      </tbody>
                    </table>
                  </div>
                ) : tablaMensualSeleccionada.tipo_reporte === 'PRACTICAS_HIGIENICAS_SST' ? (
                  empleadoDetalleHigiene ? (
                    <div className="animate-fade-in">
                      <div className="flex items-center gap-4 mb-4">
                        <button onClick={() => setEmpleadoDetalleHigiene(null)} className="text-xs font-bold text-fuchsia-700 bg-fuchsia-100 hover:bg-fuchsia-600 hover:text-white px-4 py-2 rounded-xl transition-all shadow-sm border border-fuchsia-200 cursor-pointer">
                          Volver al resumen
                        </button>
                        <h3 className="text-sm font-black text-slate-800 uppercase bg-slate-100 px-4 py-2 rounded-xl border border-slate-200">
                          Empleado Evaluado: <span className="text-fuchsia-700">{empleadoDetalleHigiene}</span>
                        </h3>
                      </div>
                      <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
                        <table className="w-full text-left border-collapse min-w-[1050px]">
                          <thead>
                            <tr className="bg-fuchsia-600 text-white text-[9px] uppercase tracking-wider text-center">
                              <th className="p-2 border-r border-fuchsia-500/50" rowSpan="2">FECHA</th>
                              <th className="p-2 border-r border-fuchsia-500/50" rowSpan="2">TURNO</th>
                              <th className="p-2 border-r border-fuchsia-500/50" rowSpan="2">EVALUADOR</th>
                              <th className="p-1 border-r border-fuchsia-500/50 border-b" colSpan="7">MUJERES</th>
                              <th className="p-1 border-r border-fuchsia-500/50 border-b" colSpan="7">HOMBRES</th>
                              <th className="p-2" rowSpan="2">ACCIÓN CORRECTIVA</th>
                            </tr>
                            <tr className="bg-fuchsia-700 text-white text-[8px] font-bold text-center">
                              <th className="p-1 border-r border-fuchsia-500/50">Cabello</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Maquillaje</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Uñas</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Sin Joyas</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Dotación</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Loción</th>
                              <th className="p-1 border-r border-fuchsia-500/50 bg-fuchsia-800">Heridas</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Cabello</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Sin Joyas</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Barba</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Dotación</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Loción</th>
                              <th className="p-1 border-r border-fuchsia-500/50">Heridas</th>
                              <th className="p-1 border-r border-fuchsia-500/50 bg-fuchsia-800">Uñas</th>
                            </tr>
                          </thead>
                          <tbody>
                            {renderDetalleDiarioEmpleadoHigiene(
                              tablaMensualSeleccionada.registros.filter(
                                r => obtenerNombreEvaluadoHigiene(r) === empleadoDetalleHigiene
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm animate-fade-in">
                      <table className="w-full text-left border-collapse min-w-[700px]">
                        <thead>
                          <tr className="bg-fuchsia-600 text-white text-[10px] uppercase tracking-wider text-center">
                            <th className="p-3 border-r border-fuchsia-500/50 text-left pl-4">EMPLEADO EVALUADO</th>
                            <th className="p-3 border-r border-fuchsia-500/50">CARGO</th>
                            <th className="p-3 border-r border-fuchsia-500/50 bg-fuchsia-700/50">DÍAS EVALUADOS</th>
                            <th className="p-3 border-r border-fuchsia-500/50 bg-emerald-600/40">CUMPLIMIENTO PERFECTO</th>
                            <th className="p-3 border-r border-fuchsia-500/50 bg-red-500/40">DÍAS CON FALLOS</th>
                            <th className="p-3 w-40">ACCIÓN</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renderResumenHigiene(tablaMensualSeleccionada)}
                        </tbody>
                      </table>
                    </div>
                  )
                ) : tablaMensualSeleccionada.tipo_reporte === 'CONTROL_PLAGAS_SST' ? (
                  <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
                    <table className="w-full text-left border-collapse min-w-[1000px]">
                      <thead>
                        <tr className="bg-violet-600 text-white text-[10px] uppercase tracking-wider text-center">
                          <th className="p-3 border-r border-violet-500/50">FECHA</th>
                          <th className="p-3 border-r border-violet-500/50">TURNO</th>
                          <th className="p-3 border-r border-violet-500/50">TIPO DE PLAGA IDENTIFICADA</th>
                          <th className="p-3 border-r border-violet-500/50">UBICACIÓN/ÁREA O LUGAR</th>
                          <th className="p-3 border-r border-violet-500/50">EVIDENCIA ENCONTRADA</th>
                          <th className="p-3 border-r border-violet-500/50">RESPONSABLE VERIFICACIÓN</th>
                          <th className="p-3">ACCIONES CORRECTIVAS O PREVENTIVAS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderTablaMensualPlagas(tablaMensualSeleccionada)}
                      </tbody>
                    </table>
                  </div>
                ) : tablaMensualSeleccionada.tipo_reporte === 'LIMPIEZA_DESINFECCION_SST' ? (
                  <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
                    <table className="w-full text-left border-collapse min-w-[800px]">
                      <thead>
                        <tr className="bg-blue-600 text-white text-[9px] sm:text-[10px] uppercase tracking-wider text-center">
                          <th className="p-2 border-r border-blue-500/50" rowSpan="2">ASPECTO</th>
                          <th className="p-2 border-r border-blue-500/50" rowSpan="2">ÍTEMS A INSPECCIONAR</th>
                          <th className="p-1 border-b border-blue-500/50" colSpan={new Date(tablaMensualSeleccionada.anio, tablaMensualSeleccionada.mes, 0).getDate()}>DÍAS DEL MES</th>
                        </tr>
                        <tr className="bg-blue-700 text-white text-[8px] sm:text-[9px] font-black text-center">
                          {Array.from({ length: new Date(tablaMensualSeleccionada.anio, tablaMensualSeleccionada.mes, 0).getDate() }, (_, i) => (
                            <th key={i} className="p-1 border-r border-blue-500/50 w-5 md:w-6">{i + 1}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {renderTablaMensualLimpieza(tablaMensualSeleccionada)}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="overflow-x-auto rounded-xl border border-slate-200 shadow-sm">
                    <table className="w-full text-left border-collapse min-w-[600px]">
                      <thead>
                        <tr className="bg-emerald-600 text-white text-[9px] sm:text-[10px] uppercase tracking-wider text-center">
                          <th className="p-2 border-r border-emerald-500/50" rowSpan="2">Día</th>
                          <th className="p-2 border-r border-b border-emerald-500/50" colSpan="6">Tipo de Residuo Generado</th>
                          <th className="p-2 border-r border-emerald-500/50" rowSpan="2">Cantidad<br/>(KG)</th>
                          <th className="p-2" rowSpan="2">Entregado A</th>
                        </tr>
                        <tr className="bg-emerald-700 text-white text-[9px] sm:text-[10px] uppercase tracking-wider text-center">
                          <th className="p-1 border-r border-emerald-500/50">Papel</th>
                          <th className="p-1 border-r border-emerald-500/50">Cartón</th>
                          <th className="p-1 border-r border-emerald-500/50">Plástico</th>
                          <th className="p-1 border-r border-emerald-500/50">Vidrio</th>
                          <th className="p-1 border-r border-emerald-500/50">Latas</th>
                          <th className="p-1 border-r border-emerald-500/50">Otros</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderFilasMensualesResiduos(tablaMensualSeleccionada).filas}
                        <tr className="bg-slate-100 font-black text-slate-800 text-center border-t-2 border-emerald-600">
                          <td className="p-2 border-r border-slate-200 text-xs sm:text-sm" colSpan="7">TOTAL MENSUAL RECOLECTADO</td>
                          <td className="p-2 border-r border-slate-200 text-emerald-700 text-sm sm:text-base">{renderFilasMensualesResiduos(tablaMensualSeleccionada).sumaTotalKg.toFixed(1)} KG</td>
                          <td className="p-2"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                {tablaMensualSeleccionada.firma_cierre && !['PRACTICAS_HIGIENICAS_SST', 'CONTROL_PLAGAS_SST', 'CONTROL_TEMPERATURAS', 'AGUA_POTABLE_SST'].includes(tablaMensualSeleccionada.tipo_reporte) && (
                  <div className="mt-6 pt-4 border-t border-slate-200 flex flex-col items-center">
                    <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Cierre de Mes Diligenciado por:</p>
                    <p className="text-xs font-bold text-slate-800 mb-2">{tablaMensualSeleccionada.evaluador_cierre}</p>
                    <div className="bg-white border border-slate-200 rounded-xl p-2 flex justify-center shadow-sm w-48">
                      <img src={tablaMensualSeleccionada.firma_cierre} alt="Firma Cierre" className="max-h-16 w-auto object-contain mix-blend-multiply" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </SafePortalModal>
      )}

      {/* MODAL 2: DETALLES ESTÁNDAR (CON VISOR DE FOTOS POR PREGUNTA) */}
      {detalleSeleccionado && (
        <SafePortalModal>
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-md flex justify-center items-center p-4 z-[99999] animate-fade-in">
            <div className="bg-white/90 backdrop-blur-3xl rounded-[32px] p-6 sm:p-8 max-w-4xl w-full shadow-[0_30px_90px_rgba(0,0,0,0.3)] border border-white flex flex-col my-auto relative overflow-hidden" style={{ maxHeight: '90vh' }}>
              
              <div className="flex justify-between items-center border-b border-slate-200 pb-4 mb-4 flex-shrink-0">
                <div>
                  <span className={`${detalleSeleccionado.tipo_formulario === 'INSPECCION_SST' ? 'bg-blue-100 text-blue-800' : detalleSeleccionado.tipo_formulario === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'bg-teal-100 text-teal-800' : detalleSeleccionado.tipo_formulario === 'AUTOREPORTE_SALUD' ? 'bg-indigo-100 text-indigo-800' : detalleSeleccionado.tipo_formulario === 'ACCION_CORRECTIVA_MP' ? 'bg-rose-100 text-rose-800' : detalleSeleccionado.tipo_formulario === 'MANTENIMIENTO_EQUIPOS_SST' ? 'bg-orange-100 text-orange-800' : 'bg-amber-100 text-amber-800'} text-[10px] font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider`}>
                    {detalleSeleccionado.tipo_formulario === 'INSPECCION_SST' ? 'Detalle Inspección' : detalleSeleccionado.tipo_formulario === 'CONTROL_LIMPIEZA_BANOS_SST' ? 'Detalle Limpieza' : detalleSeleccionado.tipo_formulario === 'AUTOREPORTE_SALUD' ? 'Detalle Autoreporte de Salud' : detalleSeleccionado.tipo_formulario === 'ACCION_CORRECTIVA_MP' ? 'Detalle Acción Correctiva' : detalleSeleccionado.tipo_formulario === 'MANTENIMIENTO_EQUIPOS_SST' ? 'Detalle de Mantenimiento' : 'Detalle de Evento'}
                  </span>
                  <h2 className="text-lg font-black text-slate-900 uppercase mt-1">
                    {detalleSeleccionado.tipo_formulario === 'AUTOREPORTE_SALUD' 
                      ? `${detalleSeleccionado.respuestas?.nombres || ''} ${detalleSeleccionado.respuestas?.apellidos || ''}`.replace(/undefined/ig, '').trim()
                      : detalleSeleccionado.tipo_formulario === 'ACCION_CORRECTIVA_MP'
                      ? `${detalleSeleccionado.respuestas?.producto || 'Producto'} (${detalleSeleccionado.respuestas?.proveedor || 'Sin proveedor'})`
                      : detalleSeleccionado.tipo_formulario === 'MANTENIMIENTO_EQUIPOS_SST'
                      ? `${detalleSeleccionado.respuestas?.tipoEquipo || 'Equipo'} - ${detalleSeleccionado.respuestas?.tipoMantenimiento || 'Mantenimiento'}`
                      : detalleSeleccionado.pdv_centro}
                  </h2>
                  <p className="text-xs text-slate-500 font-medium">Sede: <strong className="text-slate-700">{detalleSeleccionado.pdv_centro}</strong> | Fecha: {formatearFechaLocal(detalleSeleccionado.fecha)}</p>
                </div>
                <button onClick={() => setDetalleSeleccionado(null)} className="w-8 h-8 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-full flex items-center justify-center font-black cursor-pointer transition-colors shadow-inner">✕</button>
              </div>

              <div className="overflow-y-auto flex-1 pr-2 space-y-4 pb-6 custom-scrollbar">
                
                {detalleSeleccionado.tipo_formulario === 'INSPECCION_SST' || detalleSeleccionado.tipo_formulario === 'CONTROL_LIMPIEZA_BANOS_SST' ? (
                  <>
                    {detalleSeleccionado.tipo_formulario === 'CONTROL_LIMPIEZA_BANOS_SST' && detalleSeleccionado.respuestas && (
                      <div className="bg-teal-50/50 p-4 rounded-xl border border-teal-200 flex flex-wrap gap-6 mb-4">
                        <div><p className="text-[10px] font-black text-teal-800 uppercase tracking-widest">Hora</p><p className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas.hora_limpieza || 'N/A'}</p></div>
                        <div><p className="text-[10px] font-black text-teal-800 uppercase tracking-widest">Tipo de Baño</p><p className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas.tipo_bano || 'N/A'}</p></div>
                        <div><p className="text-[10px] font-black text-teal-800 uppercase tracking-widest">Fuera de Servicio</p><p className={`text-sm font-bold ${detalleSeleccionado.respuestas.fuera_servicio === 'SI' ? 'text-red-600' : 'text-emerald-600'}`}>{detalleSeleccionado.respuestas.fuera_servicio || 'NO'}</p></div>
                      </div>
                    )}

                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-2">Checklist Registrado y Evidencias</h4>
                    {detalleSeleccionado.respuestas && Object.keys(detalleSeleccionado.respuestas).length > 0 ? (
                      Object.entries(detalleSeleccionado.respuestas)
                        .filter(([key]) => key !== 'hora_limpieza' && key !== 'tipo_bano' && key !== 'fuera_servicio')
                        .map(([idPregunta, valor], idx) => {
                        const observacionTexto = detalleSeleccionado.observaciones?.[idPregunta];
                        const esCumple = valor === 1 || valor === true || String(valor) === "1" || String(valor).toUpperCase() === "SI";
                        const textoPregunta = DICCIONARIO_PREGUNTAS[idPregunta] || `Elemento: ${idPregunta}`;
                        const fotoEvidencia = detalleSeleccionado.evidencias?.[idPregunta];

                        return (
                          <div key={idPregunta} className="bg-white/60 backdrop-blur-sm p-4 rounded-2xl border border-slate-200 shadow-sm space-y-3">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                              <div className="flex items-start gap-3 flex-1">
                                <span className="text-xs font-bold text-slate-400 mt-0.5">{idx + 1}.</span>
                                <div>
                                  <p className="text-[13px] font-bold text-slate-800 leading-tight">{textoPregunta}</p>
                                  {observacionTexto && <p className="text-[11px] text-slate-500 italic mt-1.5 bg-slate-100/80 p-2 rounded-xl border border-slate-200">💬 <strong>Obs:</strong> {observacionTexto}</p>}
                                </div>
                              </div>
                              <div className="flex items-center gap-2 shrink-0">
                                <span className={`px-3 py-1 rounded-xl text-[10px] font-black tracking-wide border shadow-sm ${esCumple ? 'bg-emerald-100 text-emerald-700 border-emerald-200' : 'bg-red-100 text-red-700 border-red-200'}`}>
                                  {esCumple ? '✓ CUMPLE' : '✕ NO CUMPLE'}
                                </span>
                              </div>
                            </div>

                            {fotoEvidencia && (
                              <div className="pt-2 border-t border-slate-200/60 flex items-center gap-3">
                                <span className="text-xs font-bold text-blue-600">📸 Evidencia Fotográfica:</span>
                                <div className="w-20 h-20 rounded-xl overflow-hidden border border-slate-300 shadow-sm cursor-pointer" onClick={() => window.open(fotoEvidencia, '_blank')} title="Click para ampliar">
                                  <img src={fotoEvidencia} alt="Evidencia Hallazgo" className="w-full h-full object-cover hover:scale-105 transition-transform" />
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-xs text-slate-500 text-center py-10">No hay datos de checklist detallados para este registro.</p>
                    )}
                  </>
                ) : detalleSeleccionado.tipo_formulario === 'AUTOREPORTE_SALUD' ? (
                  <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="bg-indigo-50/50 p-4 rounded-xl border border-indigo-200">
                        <p className="text-[10px] font-black text-indigo-800 uppercase tracking-widest mb-1">Cédula</p>
                        <p className="text-sm font-bold text-slate-800 mb-3">{detalleSeleccionado.respuestas?.identificacion || 'N/A'}</p>
                        <p className="text-[10px] font-black text-indigo-800 uppercase tracking-widest mb-1">Cargo</p>
                        <p className="text-sm font-bold text-slate-800 mb-3">{detalleSeleccionado.respuestas?.cargo || 'N/A'}</p>
                      </div>
                      <div className="bg-indigo-50/50 p-4 rounded-xl border border-indigo-200">
                        <p className="text-[10px] font-black text-indigo-800 uppercase tracking-widest mb-1">Afiliaciones</p>
                        <div className="grid grid-cols-3 gap-2 mb-3">
                          <div><span className="text-[10px] font-bold text-slate-500 block">EPS</span><span className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas?.eps || 'N/A'}</span></div>
                          <div><span className="text-[10px] font-bold text-slate-500 block">AFP</span><span className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas?.afp || 'N/A'}</span></div>
                          <div><span className="text-[10px] font-bold text-slate-500 block">ARL</span><span className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas?.arl || 'N/A'}</span></div>
                        </div>
                      </div>
                    </div>
                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-2 mt-4">Síntomas</h4>
                    <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
                      <p className="text-sm text-slate-800 font-medium">{detalleSeleccionado.respuestas?.sintomas}</p>
                    </div>
                  </>
                ) : detalleSeleccionado.tipo_formulario === 'ACCION_CORRECTIVA_MP' ? (
                  <>
                    <div className="bg-rose-50/50 p-4 rounded-xl border border-rose-200 space-y-3">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <p className="text-[10px] font-black text-rose-800 uppercase tracking-widest">Cantidad Rechazada</p>
                          <p className="text-base font-black text-slate-800">{detalleSeleccionado.respuestas?.cantidad_rechazada || '0'} unidades</p>
                        </div>
                        <div>
                          <p className="text-[10px] font-black text-rose-800 uppercase tracking-widest">Fecha de Aplicación</p>
                          <p className="text-sm font-bold text-slate-800">{formatearFechaLocal(detalleSeleccionado.respuestas?.fecha_aplicacion)}</p>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4 border-t border-rose-200/60 pt-3">
                        <div>
                          <p className="text-[10px] font-black text-rose-800 uppercase tracking-widest">Lote</p>
                          <p className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas?.lote || 'N/A'}</p>
                        </div>
                        <div>
                          <p className="text-[10px] font-black text-rose-800 uppercase tracking-widest">Vencimiento</p>
                          <p className="text-sm font-bold text-slate-800">{formatearFechaLocal(detalleSeleccionado.respuestas?.fecha_vencimiento)}</p>
                        </div>
                      </div>
                      <div>
                        <p className="text-[10px] font-black text-rose-800 uppercase tracking-widest">Motivo del Rechazo</p>
                        <p className="text-xs font-bold text-rose-900 bg-rose-100/80 px-3 py-2 rounded-lg mt-1">{detalleSeleccionado.respuestas?.motivo_rechazo || 'N/A'}</p>
                      </div>
                    </div>

                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-2 mt-4">Acción Correctiva Definida</h4>
                    <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
                      <p className="text-sm font-bold text-slate-800">{detalleSeleccionado.respuestas?.accion_correctiva || 'N/A'}</p>
                    </div>
                  </>
                ) : detalleSeleccionado.tipo_formulario === 'MANTENIMIENTO_EQUIPOS_SST' ? (
                  <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="bg-orange-50/50 p-4 rounded-xl border border-orange-200">
                        <p className="text-[10px] font-black text-orange-800 uppercase tracking-widest mb-1">Información del Equipo</p>
                        <p className="text-sm font-bold text-slate-800 mb-1">Tipo: {detalleSeleccionado.respuestas?.tipoEquipo || 'N/A'}</p>
                        <p className="text-xs text-slate-600 mb-1">Marca / Modelo: <span className="font-bold text-slate-800">{detalleSeleccionado.respuestas?.marcaEquipo || 'N/A'}</span></p>
                        <p className="text-xs text-slate-600">Estado: <span className={`font-black uppercase ${detalleSeleccionado.respuestas?.estadoEquipo === 'OPERATIVO' ? 'text-emerald-600' : detalleSeleccionado.respuestas?.estadoEquipo === 'FUERA_DE_SERVICIO' ? 'text-red-600' : 'text-amber-600'}`}>{detalleSeleccionado.respuestas?.estadoEquipo || 'N/A'}</span></p>
                      </div>
                      <div className="bg-orange-50/50 p-4 rounded-xl border border-orange-200">
                        <p className="text-[10px] font-black text-orange-800 uppercase tracking-widest mb-1">Detalles del Mantenimiento</p>
                        <p className="text-sm font-bold text-slate-800 mb-1">Categoría: {detalleSeleccionado.respuestas?.tipoMantenimiento || 'N/A'}</p>
                        <p className="text-xs text-slate-600">Empresa Contratista: <span className="font-bold text-slate-800">{detalleSeleccionado.respuestas?.empresaProveedor || 'N/A'}</span></p>
                        <p className="text-xs text-slate-600">Técnico Responsable: <span className="font-bold text-slate-800">{detalleSeleccionado.respuestas?.nombreTecnico || 'N/A'}</span></p>
                        <p className="text-xs text-slate-600 mt-1">Fecha Servicio: {formatearFechaLocal(detalleSeleccionado.respuestas?.fechaMantenimiento)}</p>
                      </div>
                    </div>
                    
                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-2 mt-4">Descripción y Hallazgos</h4>
                    <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
                      <p className="text-sm text-slate-800 font-medium leading-relaxed">{detalleSeleccionado.respuestas?.descripcion || 'No hay descripción'}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-2">Información del Evento</h4>
                    <div className="bg-amber-50/50 p-4 rounded-xl border border-amber-200">
                      <p className="text-[10px] font-black text-amber-800 uppercase tracking-widest mb-1">Descripción</p>
                      <p className="text-sm text-slate-700 bg-white p-3 rounded-lg border border-slate-200 shadow-sm leading-relaxed">{detalleSeleccionado.respuestas?.descripcion}</p>
                    </div>
                  </>
                )}

                {/* FIRMAS DIGITALES */}
                {detalleSeleccionado.evidencias && (detalleSeleccionado.evidencias.firma_evaluador || detalleSeleccionado.evidencias.firma_reportante || detalleSeleccionado.evidencias.firma_colaborador || detalleSeleccionado.evidencias.firma_responsable) && (
                  <div className="mt-8 pt-6 border-t border-slate-200">
                    <h4 className="text-xs font-black text-slate-400 uppercase tracking-wider mb-4">Firmas Digitales Registradas</h4>
                    <div className="flex flex-wrap gap-4">
                      {(detalleSeleccionado.evidencias.firma_evaluador || detalleSeleccionado.evidencias.firma_reportante || detalleSeleccionado.evidencias.firma_responsable) && (
                        <div className="bg-white border border-slate-200 rounded-2xl p-4 flex flex-col justify-center items-center shadow-inner w-full sm:max-w-[200px] overflow-hidden">
                          <p className="text-[10px] font-black text-slate-500 uppercase mb-2 text-center w-full truncate">Responsable / Evaluador</p>
                          <img src={detalleSeleccionado.evidencias.firma_evaluador || detalleSeleccionado.evidencias.firma_reportante || detalleSeleccionado.evidencias.firma_responsable} alt="Firma" className="max-h-20 w-auto object-contain mix-blend-multiply" />
                        </div>
                      )}
                      {detalleSeleccionado.evidencias.firma_colaborador && (
                        <div className="bg-white border border-slate-200 rounded-2xl p-4 flex flex-col justify-center items-center shadow-inner w-full sm:max-w-[200px] overflow-hidden">
                          <p className="text-[10px] font-black text-slate-500 uppercase mb-2 text-center w-full truncate">Colaborador</p>
                          <img src={detalleSeleccionado.evidencias.firma_colaborador} alt="Firma Colaborador" className="max-h-20 w-auto object-contain mix-blend-multiply" />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </SafePortalModal>
      )}

    </div>
  );
}